import { render, staticRenderFns } from "./ExpedientsView.vue?vue&type=template&id=d354922c&lang=pug"
import script from "./ExpedientsView.vue?vue&type=script&lang=ts"
export * from "./ExpedientsView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d354922c')) {
      api.createRecord('d354922c', component.options)
    } else {
      api.reload('d354922c', component.options)
    }
    module.hot.accept("./ExpedientsView.vue?vue&type=template&id=d354922c&lang=pug", function () {
      api.rerender('d354922c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Expedients/ExpedientsView.vue"
export default component.exports